import { DateValue } from '@/modules/corporate/modules/tags/types';
import {
  FilterD1InputType,
  FilterD2InputType,
  FilterGroupV2InputType,
  FilterGroupV2Type,
  FilterOperatorEnum,
  FilterPropertyTypeEnum,
  RestrictedFilterGroupType,
  TagTypeEnum,
} from '@/types/schema';

import { DateValueTypeEnumSM } from '../components/FilterValues/types';
import { isDateFilterEmpty, isDynamicDateFilterEmpty } from '../components/FilterValues/utils';
import { DEFAULT_GROUP, VALUE_DISABLED_FOR_OPERATORS } from '../consts';
import { FilterGroupInput, FilterInputsD2 } from '../types';

const isFilterValueEmpty = (filter: FilterInputsD2) => {
  if (
    filter.property?.type === FilterPropertyTypeEnum.Tag &&
    filter.property.tag?.type === TagTypeEnum.Date
  ) {
    const selectedFilterValue = filter.value ? JSON.parse(filter.value) : undefined;
    const dateTagValue = {
      startTime: selectedFilterValue?.startTime,
      endTime: selectedFilterValue?.endTime,
    } as DateValue;

    if (selectedFilterValue?.dateValueType === DateValueTypeEnumSM.Dynamic) {
      return isDynamicDateFilterEmpty(
        selectedFilterValue?.offsetDays,
        selectedFilterValue?.offsetRelation,
      );
    }

    return isDateFilterEmpty(dateTagValue, filter.operator === FilterOperatorEnum.Between);
  }

  return !filter.value;
};

export const isFilterGroupEmpty = (filterGroup?: FilterGroupInput | null) => {
  if (!filterGroup) {
    return false;
  }

  const { filters } = filterGroup;
  let error = false;
  filters.forEach((filter) => {
    const emptyValue = filter?.filters?.find(
      (val) =>
        val.operator &&
        !VALUE_DISABLED_FOR_OPERATORS.includes(val.operator) &&
        isFilterValueEmpty(val),
    );
    if (emptyValue) {
      error = true;
    }
  });

  return error;
};

export const adaptFilterGroups = (
  filterGroup?: FilterGroupInput,
): FilterGroupV2InputType | undefined => {
  if (!filterGroup) {
    return undefined;
  }

  let isAnyFilterFull = false;

  const filters: FilterD1InputType[] = [];
  filterGroup.filters.forEach((filterD1) => {
    const filtersDepth2: FilterD2InputType[] = [];
    filterD1.filters.forEach((filterD2) => {
      if (filterD2.operator) {
        isAnyFilterFull = true;
        filtersDepth2.push({
          operator: filterD2.operator,
          value: filterD2.value,
          property: {
            type: filterD2.property?.type,
            value: filterD2.property?.value,
          },
        } as FilterD2InputType);
      }
    });
    if (filtersDepth2.length) {
      filters.push({
        operator: filterD1.operator,
        filters: filtersDepth2,
      });
    }
  });

  if (isAnyFilterFull) {
    return { operator: filterGroup.operator, filters };
  }

  return undefined;
};

export const adaptFilterGroupInput = (
  filterGroup?: FilterGroupV2Type | RestrictedFilterGroupType | null,
): FilterGroupInput => {
  if (!filterGroup) {
    return DEFAULT_GROUP;
  }
  return {
    operator: filterGroup.operator,
    filters: filterGroup.filters.map((filterD1) => ({
      operator: filterD1.operator,
      filters: filterD1.filters.map((filterD2) => ({
        operator: filterD2.operator,
        value: filterD2.value,
        property: {
          type: filterD2.property?.type,
          value: filterD2.property?.value,
          tag: filterD2.property?.tag,
        },
      })),
    })),
  };
};
